// for manage group
export const API_STATUS = "API_STATUS";
export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const DELETE_GROUP = "DELETE_GROUP";
export const EDIT_GROUP = "EDIT_GROUP";
export const ADD_GROUP = "ADD_GROUP";
export const MANAGE_GROUP = "MANAGE_GROUP";

// for manage user
export const GET_USER_LIST = "GET_USER_LIST";
export const DELETE_USER = "DELETE_USER";
export const EDIT_USER = "EDIT_USER";
export const ADD_USER = "ADD_USER";

// for data deletion
export const GET_DELETED_DATA = "GET_DELETED_DATA";

// upload batch files
export const LIST_BOX_FILES = "LIST_BOX_FILES";
export const UPLOAD_BOX_FILES = "UPLOAD_BOX_FILES";
export const BATCH_TYPE = "BATCH_TYPE";
export const UPLOAD_DATA = "UPLOAD_DATA";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
export const PRODUCT_SUB_FOLDER = "PRODUCT_SUB_FOLDER";

//Manage Output
export const GET_OUT_PUT_LIST = "GET_OUT_PUT_LIST";
export const GET_OUT_PUT_URL = "GET_OUT_PUT_URL";
export const SUBMIT_OUT_PUT_FILE_UPLOAD = "SUBMIT_OUT_PUT_FILE_UPLOAD";
export const REJECT_OUT_PUT_FILE_BATCH = "REJECT_OUT_PUT_FILE_BATCH";

//Batch Monitor
export const GET_BATCH_DATA = "GET_BATCH_DATA";
export const LIST_BATCH_RECORD = "LIST_BATCH_RECORD";
export const GET_DATA_TO_FILTER = "GET_DATA_TO_FILTER";

//Audit Data
export const GET_AUDIT_LIST = "GET_AUDIT_LIST";
export const CLEAR_API_STATUS = "CLEAR_API_STATUS";
export const GET_AUDIT_DETAILS = "GET_AUDIT_DETAILS";
export const GET_USER_ACTIVITY = "GET_USER_ACTIVITY";
export const GET_USER_NAME = "GET_USER_NAME";
export const GET_FILTERED_USER_ACTIVITY = "GET_FILTERED_USER_ACTIVIT";
export const GET_DATA_POINT_CALCULATION = "GET_DATA_POINT_CALCULATION";
export const GET_DP_DETAILS = "GET_DP_DETAILS";
export const GET_MERGE_PROJECTS = "GET_MERGE_PROJECTS";
export const GET_MERGE_BATCHES = "GET_MERGE_BATCHES";
export const API_STATUS_MASTER = "API_STATUS_MASTER";
export const GET_MERGED_FILES = "GET_MERGED_FILES";
export const CLEAR_GET_MERGED_FILES = "CLEAR_GET_MERGED_FILES";
export const GET_AUDIT_HISTORY = "GET_AUDIT_HISTORY";
export const GET_VISUALIZATION_DATA = "GET_VISUALIZATION_DATA";
export const VISUALIZATION_SUBMIT_STATUS = "VISUALIZATION_SUBMIT_STATUS";
export const GET_REJECTED_BATCHES_FOR_COL_INSERTION =
  "GET_REJECTED_BATCHES_FOR_COL_INSERTION";
export const BATCHES_APPROVED_STATUS = "BATCHES_APPROVED_STATUS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_EXTRACTED_DATA = "GET_EXTRACTED_DATA";
export const VISUALIZATION_DATA_HISTORY = "VISUALIZATION_DATA_HISTORY";
export const VISUALIZATION_SUBMIT_QUERY = "VISUALIZATION_SUBMIT_QUERY";
export const GET_VISUALIZATION_PROJECTS = "GET_VISUALIZATION_PROJECTS";
export const VISUALIZATION_SUBMIT_RESULT = "VISUALIZATION_SUBMIT_RESULT";
export const REGENERATE_VISUALIZATION_RESULT =
  "REGENERATE_VISUALIZATION_RESULT";
export const GET_VISUALIZATION_DETAILS = "GET_VISUALIZATION_DETAILS";

export const GET_DATA_TO_FILTER_SEARCH = "GET_DATA_TO_FILTER_SEARCH";
export const GET_VISUALIZATION_TABLE_DATA = "GET_VISUALIZATION_TABLE_DATA";
export const GET_VISUALIZATION_BOX_DATA = "GET_VISUALIZATION_BOX_DATA";
// export const GET_FILTERED_DATA = "GET_FILTERED_DATA";
// export const FILTERS_VALUE_API_STATUS = "FILTERS_VALUE_API_STATUS";
// export const GET_ALL_PROJECT_NAMES = "GET_ALL_PROJECT_NAMES";
// export const GET_ALL_BATCH_NAMES = "GET_ALL_BATCH_NAMES";
// export const GET_ALL_MBR_NAMES = "GET_ALL_MBR_NAMES";
// export const GET_ALL_GROUP_USER_NAMES = "GET_ALL_GROUP_USER_NAMES";
// export const GET_ALL_PARAMETER_NAMES = "GET_ALL_PARAMETER_NAMES";
// export const GET_LOG_PDF_URL = "GET_LOG_PDF_URL";
export const GET_HISTORY_DATA = "GET_HISTORY_DATA";
export const GET_HISTORY_PREVIEW_DATA = "GET_HISTORY_PREVIEW_DATA";
export const HANDLE_DELETE = "HANDLE_DELETE";
export const HANDLE_REFRESH_BOX_FOLDERS = "HANDLE_REFRESH_BOX_FOLDERS";
export const HANDLE_DELETE_BATCH_LOGS = "HANDLE_DELETE_BATCH_LOGS";
export const HANDLE_DELETE_PROJECT_LOGS = "HANDLE_DELETE_PROJECT_LOGS";

export const GET_DP_CUSTOM_WORD = "GET_DP_CUSTOM_WORD";
export const GET_DP_FORMULAS_LIST = "GET_DP_FORMULAS_LIST";
export const GET_DP_CALCULATION_LINK = "GET_DP_CALCULATION_LINK";
export const GET_DP_FILTER_ONE = "GET_DP_FILTER_ONE";
